import { observable } from 'mobx';
import {
    BaseXYAxisChartOptions,
    LegendOptions,
    MetaInfoOptions,
} from '@sprinklr/stories/hyperspaceWidgets/types';
import { HyperSpaceLineChartWidgetOptions } from './types';
import { WidgetOptionsImpl } from 'models/Widget/WidgetOptions';
import { LegendOptionsImpl } from '../options';
import { TrendingPostOptionsImpl } from '../withTrendingPost/options';
import { SpikesImpl } from './spikes/options';
export class HyperSpaceLineChartWidgetOptionsImpl extends WidgetOptionsImpl
    implements HyperSpaceLineChartWidgetOptions {
    @observable trendingPost = new TrendingPostOptionsImpl();
    @observable spikes = new SpikesImpl();
    @observable line = {
        strokeWidth: 2,
    };
    @observable pointMarkers = {
        enabled: false,
        size: 10,
    };
    @observable baseXYChartOptions: BaseXYAxisChartOptions = {
        dataLabels: {
            enabled: false,
            fontSize: 30,
            formats: {
                numberFormat: {
                    decimals: 0,
                    useShortened: true,
                },
                dateFormat: {
                    autoFormat: true,
                    formatString: 'dd MMM',
                },
            },
        },
        overflow: true,
        grid: {
            enabled: false,
        },
        xAxis: {
            ticks: {
                enabled: true,
                angle: {
                    enabled: true,
                    auto: true,
                    degrees: null,
                },
                formats: {
                    numberFormat: {
                        decimals: 0,
                        useShortened: true,
                    },
                    dateFormat: {
                        autoFormat: true,
                        formatString: 'dd MMM',
                    },
                },
                numTicks: 5,
            },
            enabled: true,
            label: {
                enabled: true,
                size: 50,
            },
            line: {
                enabled: false,
                stroke: '',
                strokeWidth: 1,
            },
        },
        yAxis: {
            ticks: {
                enabled: true,
                formats: {
                    numberFormat: {
                        decimals: 0,
                        useShortened: true,
                    },
                    dateFormat: {
                        autoFormat: true,
                        formatString: 'dd MMM',
                    },
                },
                //TODO: how should we actually set initial value
                numTicks: 5,
            },
            enabled: true,
            label: {
                enabled: true,
                size: 50,
            },
            line: {
                enabled: false,
                stroke: '',
                strokeWidth: 1,
            },
        },
    };
    @observable zeroFill = true;
    @observable legend: LegendOptions = new LegendOptionsImpl();
    @observable metaInfoOptions: MetaInfoOptions = {
        color: {
            enabled: false,
            type: 'fill',
        },
        image: {
            enabled: false,
        },
    };
}
